(function () {
	document.body.classList.add('has-js');
}());
